import { render, staticRenderFns } from "./ICalendar.vue?vue&type=template&id=134bbb7e&scoped=true&"
import script from "./ICalendar.vue?vue&type=script&lang=js&"
export * from "./ICalendar.vue?vue&type=script&lang=js&"
import style0 from "./ICalendar.vue?vue&type=style&index=0&id=134bbb7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134bbb7e",
  null
  
)

export default component.exports